module.exports = __webpack_public_path__ + "img/googleplay.d9f1a642.png";